import { GeoPoint } from 'firebase/firestore'

export class TransactionLog {

    public identifier: string|undefined = undefined

    public creationDate: Date = new Date()
    public timeStamp: Date|undefined = new Date()
    public updateTimestamp: Date|undefined = new Date()
    public fieldName: string|undefined = undefined
    public newValue: any|null = null
    public oldValue: any|null = null
    public operation: string|undefined = undefined

    constructor(
        public contextId: String,
        public referenceId: string,
        public referenceType: String,
        public userDisplayName: string,
        public userId: string,
        public deviceName?: string,
        public appName?: string,
        public appVersion?: string,
        public appBuildNo?: string,
        public appPlatform?: string,
        public appPlatformVersion?: string,
        public locationCoordinates?: GeoPoint
    ) {}

    setCreate(newValue: any) {
        this.operation = OperationTypes.CREATE
        this.newValue = newValue
    }

    setUpdate(fieldName: string, oldValue: any, newValue: any) {
        this.operation = OperationTypes.UPDATE
        this.fieldName = fieldName
        this.oldValue = oldValue
        this.newValue = newValue

    }

    setDelete(fieldName: string|null, oldValue: any) {
        this.operation =  OperationTypes.UPDATE
        this.oldValue = oldValue
        if (fieldName != null) this.fieldName = fieldName
        this.newValue = null
    }

    setDocumentDelete(oldValue: any) {
        this.operation = OperationTypes.DELETE
        this.oldValue = oldValue
        this.newValue = null
    }

    setHitReport(
        gameRecord: any,
        associatedSamples: any[],
        reportGuid: string,
        hitReportData: any
    ) {
        this.operation = OperationTypes.HI_TIER_REPORT
        this.newValue = {
            gameRecord,
            associatedSamples,
            reportGuid,
            hitReportData
        }
    }

    public toString(): string {
        return JSON.stringify(this)
    }
}

enum OperationTypes {
    CREATE = "create",
    UPDATE = "update",
    DELETE = "delete",
    HI_TIER_REPORT = "HIT"
}